import {EingabeStepComponent} from "../eingabe/eingabe.step.component";
import {Component, HostListener, OnInit} from "@angular/core";
import {StepService} from "../../services/step.service";
import {Router} from "@angular/router";
import {FoerdermittelcheckRequestService} from "../services/request.service";
import {ElementService} from "../../services/element.service";
import {PortalService} from "../../services/portal.service";
import {TranslateService} from "@ngx-translate/core";
import {FoerdermittelcheckConstants} from "../foerdermittelcheck.constants";
import {BackendService} from "../../services/backend.service";


/**
 * Component for the restult page of the foerdermittelcheck.
 */
@Component({
    selector: 'app-foerdermittelcheck-ergebnis',
    templateUrl: './ergebnis.component.html',
    standalone: false
})

export class ErgebnisComponent extends EingabeStepComponent implements OnInit {
  /**
   * indicator if there is a result available or not.
   */
  hasResult: boolean;

  /**
   * textkey prefix
   */
  textkeyPrefix: string = "foerdermittelcheck.ergebnis";

  /**
   * data for the dialog registration
   */
  dialogData: any = {};

  /**
   * hide report download
   */
  hideReportDownload: boolean;

  /**
   * Toggle to force the Dialog/NL-Box
   */
  forceDialog: boolean = false;

  /**
   * URL for the report to download
   */
  reportUrl: string;

  /**
   * URL for showing the SDC
   */
  sdcUrl: string;

  /**
   * URL for showing the MOC
   */
  mocUrl: string;

  /**
   * URL for showing the WPC
   */
  wpcUrl: string;

  /**
   * toggle if we want to display the download module
   */
  showDownload: boolean;

  /**
   * current portalId
   */
  portalId: string;

  /**
   * toggle if this is an internal project or not.
   */
  internalPortal: boolean;

  /**
   * holds the id of the html element where to jump to after click on dialog hint
   */
  idTargetElement: string = null;

  /**
   * true if user selects measure with fossil energy source
   */
  isFossilEnergy: boolean = false;

  /**
   * fossil energy programs
   */
  fossilEnergyProgram: string;

  /**
   * holds the previous link
   */
  previousLink: string;

  /**
   * placeholder for the text
   */
  placeholder: any = {};

  /**
   * toggle the selected measure
   */
  toggleMeasure: {[category: string] :boolean} = {};

  /**
   * toggle the selected funding type
   */
  toggleFundingType: { [fundingType: string]: boolean} = {};

  /**
   * holds the all funding programs
   */
  visiblePrograms: any[] = [];

  /**
   * holds the count of the funding programs shown per page
   */
  itemsPerPage: number = FoerdermittelcheckConstants.ITEMS_PER_PAGE;

  /**
   * start index for the pagination, initial value is 0
   */
  startIndex: number = 0;

  /**
   * holds the count of the funding programs
   */
  countVisiblePrograms: number;

  /**
   * set to true if we have only bud as funding source
   */
  isBundOnly: boolean;

  /**
   * toggle filter content
   */
  toggleFilter: boolean = false;

  /**
   * show (part of) table for medium up
   */
  showForMediumUp: boolean = false;

  /**
   * show part of table for large only
   */
  showForLargeOnly: boolean = false;

  /**
   * measures without programs
   */
  measuresWithoutProgram: any[] = [];

  /**
   * holds the keys of an object
   */
  objectKeys = Object.keys;

  /**
   * constructor
   *
   * @param stepService
   * @param router
   * @param requestService
   * @param elementService
   * @param portalService
   * @param translateService
   * @param backendService
   */
  constructor(protected stepService: StepService, protected router: Router, protected requestService: FoerdermittelcheckRequestService, protected elementService: ElementService, protected portalService: PortalService, protected translateService: TranslateService, protected backendService: BackendService) {
    super(stepService, router, requestService, elementService, portalService);
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    super.ngOnInit();

    this.anfrage = this.requestService.getAnfrage();

    if(this.anfrage?.programs) {
      this.visiblePrograms = this.anfrage.programs;

      //count of visible programs for pagination
      this.countVisiblePrograms = this.visiblePrograms.length;
      //we have a result, even if no programs
      this.hasResult = true;
    }

    //show errorpage if no data available
    if(!this.visiblePrograms) {
      this.hasResult = false;
    }

    // get the current portalId
    this.portalId = this.portalService.currentPortalId;
    this.internalPortal = this.portalService.isInternalPortal();

    //check if there is a report url
    this.reportUrl = this.anfrage.report ?? null;

    // download module
    this.hideReportDownload = this.portalService.getConfigAsBool('embed.newsletter.report.download');
    this.showDownload = !this.hideReportDownload && this.reportUrl && !this.internalPortal;

    //init attention callout in case of fossil energy
    this.initAttentionCallout();

    // init relink urls
    this.initRelinkUrl();

    // should we force to see the dialog box
    this.forceDialog = this.portalService.getConfigAsBool('embed.newsletter.force');
    this.initDialogData();

    //init previous link to go back to last step
    this.initPreviousLink();

    //init fuding types and selected measures
    this.initFundingTypes();
    this.initSelectedMeasures();

    //init target element to jump to
    this.initTargetElement();

    //get visible programs for pagination
    this.getVisibleItems();

    this.initOnWindowResize();

    //init placeholder
    this.initPlaceholder();
  }

  /**
   * init the urls to the advisor teasers
   */
  initRelinkUrl(): void {
    // init url to lead to moc
    this.mocUrl = this.portalService.getConfig("alladvisors.link.modernisierungscheck")?.replace(/\{\{portalId}}/, this.portalService.currentPortalId);
    // init url to lead to sdc
    this.sdcUrl = this.portalService.getConfig("alladvisors.link.solardachcheck")?.replace(/\{\{portalId}}/, this.portalService.currentPortalId);
    // init url to lead to wpc
    this.wpcUrl = this.portalService.getConfig("alladvisors.link.waermepumpencheck")?.replace(/\{\{portalId}}/, this.portalService.currentPortalId);

    //cases we want to show the advisor teaser
    this.mocUrl = (this.anfrage?.gefoerdertWird?.includes('altbau') && !this.isFossilEnergy) ? this.mocUrl : null;
    this.sdcUrl = (this.anfrage?.gefoerdertWird?.includes('neubau') ||
                  (this.anfrage?.gefoerdertWird?.length === 1 && this.anfrage?.gefoerdertWird?.includes('elektromobilitaet')) &&
                    !this.isFossilEnergy) ?
                  this.sdcUrl : null;
    this.wpcUrl = (this.anfrage?.programs?.length > 0 && this.isFossilEnergy) ? this.wpcUrl : null;
  }

  /**
   * init the target element
   */
  initTargetElement(): void {
    // add css class to dialog or download module
    if (this.forceDialog) {
      this.idTargetElement = 'lead';
    } else if (this.showDownload) {
      this.idTargetElement = 'download';
    }
  }

  /**
   * create data object that will be sent to the backend with the registration for the dialog
   */
  initDialogData(): void {
    this.requestService.backendService.getRequestId().subscribe(requestId => {
      this.dialogData = {
        requestId: requestId,
        bmOptinSource: window.location.href,
        doisource: 'foc'
      };
    });
  }

  /**
   * Function is called if the users registered for the dialog
   */
  dialogRegistered(result: string): void {
    const anfrage = this.requestService.getAnfrage();
    anfrage.dialogResult = result;

    this.requestService.setAnfrage(anfrage);
    this.requestService.saveDataToServer();
  }

  /**
   * init placeholder
   */
  initPlaceholder(): void {
    if(this.anfrage?.programs?.length > 0) {
      //all funding sources in the programs
      const allFundingSources = this.anfrage.programs.map(program => program.ebene);

      //filter out same funding sources and define textkeys
      let fundingSource: any[] = [...new Set(allFundingSources)];

      //check if fundingSource is only bund
      if(fundingSource.length === 1 && fundingSource[0] === 'bund') {
        this.isBundOnly = true;
      }

      fundingSource = fundingSource.map(element => this.textkeyPrefix + '.' + element);

      //subscribe new textkeys to translations
      this.translateService.get(fundingSource).subscribe(translations => {
        //set placeholder joining textkeys
        this.placeholder.fundingSources = this.joinToString(Object.values(translations));
      });

      if(this.measuresWithoutProgram.length > 0) {
        this.measuresWithoutProgram = this.measuresWithoutProgram.map(element => 'foerdermittelcheck.' + element + '.label');

        //subscribe new textkeys to translations
        this.translateService.get(this.measuresWithoutProgram).subscribe(translations => {
          //set placeholder joining textkeys
          this.placeholder.measuresWithoutProgram = this.joinToString(Object.values(translations));
        })
      }
    }
  }

  /**
   * join translation values to string
   * @param translationValues
   */
  joinToString(translationValues: any): string {
    return translationValues.slice(0, -1).join(', ') + (translationValues.length > 1 ? this.translateService.instant(this.textkeyPrefix + '.und') : '') + translationValues.slice(-1);
  }

  /**
   * init the attention callout module
   */
  initAttentionCallout(): void {
    //check if user wants to renew or change heating system with fossil energy
    if(this.anfrage?.userInput?.energietraeger === 'heizoel' &&
        (this.anfrage?.userInput?.heating === 'erneuerung_heizung' || this.anfrage?.userInput?.heating === 'umstellung_fluessiggas' || this.anfrage?.userInput?.heating === 'umstellung_erdgas')) {
      this.isFossilEnergy = true;
    }

    //check if there are fossil energy programs
    this.fossilEnergyProgram = this.anfrage?.programs?.length > 0 ? '1' : '0';
  }

  /**
   * init previous link depending on userinput
   */
  initPreviousLink(): void {
    //case elektromobilitaet
    if(this.anfrage?.gefoerdertWird?.includes('elektromobilitaet')) {
      this.previousLink = '../../eingabe/energie/electric_mobility';
      //stop here
      return;
    }
    //case gebaeudetyp !== nwg
    else if(this.anfrage?.userInput?.gebaeudetyp !== 'nichtwohngebaeude') {
      //check if path is altbau
      if(this.anfrage?.gefoerdertWird?.includes('altbau')) {
        this.previousLink = '../../eingabe/zusatzmassnahmen/additional_measures';
      }
      //check if path is neubau
      else if(this.anfrage?.gefoerdertWird?.includes('neubau')) {
        this.previousLink = '../../eingabe/energie/energetic_optimization';
      }
    }
    //case gebaeudetyp === nwg
    else {
      this.previousLink = '../../eingabe/energie/energy_efficiency';
    }
  }

  /**
   * init funding types
   */
  initFundingTypes(): void {
    if(this.anfrage?.programs?.length > 0) {
      for(const program of this.anfrage.programs) {
        // add funding types to the filter list for types
        if(program.art) {
          this.toggleFundingType[program.art] = true;
        }
      }

      //filter programs by active measures
      this.filterProgramsByActiveCategories();
    }
  }

  /**
   * init selected measures
   */
  initSelectedMeasures(): void {
    if(this.anfrage?.programs?.length > 0) {
      for(const program of this.anfrage.programs) {
        // add categories to the filter list for measures
        if (program.categories) {
          for(const category of program.categories) {
            // only add category if user searched for it
            if (this.anfrage.isMeasureSelected(category) === true) {
              this.toggleMeasure[category] = true;
            }
          }
        }
      }

      // find all measures that are selected by the user but were not in the result
      this.measuresWithoutProgram = [];
      for(const measure of Object.keys(this.anfrage.measuresMapping)) {
        // if at least one option of a measure is selected but is not in the list of availbale measures from the result
        if(this.anfrage.isMeasureSelected(measure)) {
          // if no programs for kaeltetechnik add heating
          if(!this.anfrage.isMeasureSelected('heatingsystem') &&
            !this.toggleMeasure.hasOwnProperty('heatingsystem') &&
            measure === 'additional_systems' &&
            this.anfrage.userInput.refrigeration_system_kaeltetechnik === true) {
            this.measuresWithoutProgram.push('heating.nwg');
          }
          else if(this.toggleMeasure.hasOwnProperty(measure) === false) {
            this.measuresWithoutProgram.push(measure);
          }
        }
      }
    }
  }

  /**
   * Filter programs by selected measures
   */
  filterProgramsByActiveCategories(): void {
    if(this.visiblePrograms?.length > 0) {
      //holds active categories
      const selectedMeasures = Object.keys(this.toggleMeasure).filter(measure => this.toggleMeasure[measure] === true);

      //after filtering, sort programs with the most active categories to top of list
      this.visiblePrograms = this.visiblePrograms.sort((program1, program2) => {

        const overlapProgram1 = program1.categories.length + selectedMeasures.length - new Set(program1.categories.concat(selectedMeasures)).size;
        const overlapProgram2 = program2.categories.length + selectedMeasures.length - new Set(program2.categories.concat(selectedMeasures)).size;

        return overlapProgram2 - overlapProgram1;
      });
    }
  }

  /**
   * Filter programs by funding type
   */
  filterProgramsByFundingType() :void {
    if(this.anfrage?.programs?.length > 0) {
      //holds active funding types
      const selectedFundingTypes = Object.keys(this.toggleFundingType).filter(type => this.toggleFundingType[type] === true);

      //filter programs depending on funding type
      this.visiblePrograms = this.anfrage.programs.filter(program => selectedFundingTypes.includes(program.art));

      //reset count of visible after filtering programs
      this.countVisiblePrograms = this.visiblePrograms.length;
      this.getVisibleItems();

      //get the ids from the filterd programs
      this.getFilteredProgramIds();
    }
  }

  /**
   * Toggle selected measure
   * @param selectedMeasure
   */
  toggleSelectedMeasure(selectedMeasure: string): void {
    if(this.visiblePrograms?.length > 0) {
      this.toggleMeasure[selectedMeasure] = !this.toggleMeasure[selectedMeasure];
      this.filterProgramsByActiveCategories();
    }
  }

  /**
   * Toggle selected funding types
   * @param fundingType
   */
  toggleSelectedFundingType(fundingType: string): void {
    if(this.anfrage?.programs?.length > 0) {
      this.toggleFundingType[fundingType] = !this.toggleFundingType[fundingType];
      this.filterProgramsByFundingType();
    }
  }

  /**
   * get the visible programs on one page
   */
  getVisibleItems() {
    return this.visiblePrograms.slice(this.startIndex, this.startIndex + this.itemsPerPage);
  }

  /**
   * get the program ids of the filtered visible programs
   */
  getFilteredProgramIds() {
    //save only the ids of filtered program to db
    this.anfrage.programIds = [];
    for(const visibleProgram of this.visiblePrograms) {
      this.saveData(this.anfrage.programIds.push(visibleProgram.OID));
    }
  }

  /**
   * update the start index of the pagination
   * @param startIndex
   */
  updateStartIndex(startIndex: number) {
    this.startIndex = startIndex;
    this.getVisibleItems();
  }

  /**
   * toggle to show/not show programs filter
   */
  onClickToggleFilter(): void {
    this.toggleFilter = !this.toggleFilter;
  }

  /**
   * Methods called on each window resize automatically
   */
  @HostListener('window:resize')
  initOnWindowResize(): void {
    const width = window.innerWidth;
    if(width <= FoerdermittelcheckConstants.BREAKPOINT_SMALL_SCREEN) {
      this.showForMediumUp = false;
      this.showForLargeOnly = false;
      this.itemsPerPage = FoerdermittelcheckConstants.ITEMS_PER_PAGE_SMALL_SCREEN;
    }
    else if(width > FoerdermittelcheckConstants.BREAKPOINT_SMALL_SCREEN &&
          width <= FoerdermittelcheckConstants.BREAKPOINT_MEDIUM_SCREEN) {
      this.showForMediumUp = true;
      this.showForLargeOnly = false;
      this.itemsPerPage = FoerdermittelcheckConstants.ITEMS_PER_PAGE;
    }
    else {
      this.showForMediumUp = true;
      this.showForLargeOnly = true;
      this.itemsPerPage = FoerdermittelcheckConstants.ITEMS_PER_PAGE;
    }
  }
}
